module.exports = __webpack_public_path__ + "static/media/loader.1cc4f3c7.gif";